export const encodeBase64 = (string: string | number) =>
  window.btoa(String(string));
export const decodeBase64 = (string: string | number) =>
  window.atob(String(string));
